import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Packages } from './components/Packages';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { CalendlyModal } from './components/CalendlyModal';
import { WorkedWith } from './components/WorkedWith';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import FacebookPixel from './components/FacebookPixel';
import EmailPopup from './components/EmailPopup';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

export function App() {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  useEffect(() => {
    document.title = 'Marketing Solutions | Jack Carlson Copy';
  }, []);
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <FacebookPixel />
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero openCalendly={() => setIsCalendlyOpen(true)} />
              <Services />
              <WorkedWith />
              <Packages openCalendly={() => setIsCalendlyOpen(true)} />
              <About />
              <Contact openCalendly={() => setIsCalendlyOpen(true)} />
              <Footer />
              <CalendlyModal isOpen={isCalendlyOpen} onClose={() => setIsCalendlyOpen(false)} />
              <EmailPopup />
            </>
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}